/* HiZoo 2026 redesign — tiny vanilla helpers (no dependencies). */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- gallery ---------- */
  function initGallery(gal) {
    if (gal.dataset.hzReady) return;
    gal.dataset.hzReady = '1';
    var track = $('.hz-gal__track', gal);
    var slides = $$('.hz-gal__slide', gal);
    var thumbs = $$('.hz-gal__thumb', gal);
    var cur = $('[data-hz-cur]', gal);
    if (!track || !slides.length) return;
    var index = 0;

    function setActive(i) {
      index = i;
      if (cur) cur.textContent = i + 1;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      var thumb = thumbs[i];
      if (thumb && thumb.parentNode.scrollWidth > thumb.parentNode.clientWidth) {
        thumb.parentNode.scrollTo({ left: thumb.offsetLeft - 24, behavior: 'smooth' });
      }
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) setActive(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = $('.hz-gal__nav--prev', gal);
    var next = $('.hz-gal__nav--next', gal);
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });
    gal.hzGo = go;
  }

  /* ---------- offers / price sync ---------- */
  function syncPrices(data) {
    $$('[data-hz-price]').forEach(function (el) { el.textContent = data.price; });
    $$('[data-hz-compare]').forEach(function (el) {
      el.textContent = data.compare || '';
      el.hidden = !data.compare;
    });
    $$('[data-hz-save]').forEach(function (el) {
      el.textContent = data.save || '';
      el.hidden = !data.save;
    });
  }

  function initOffers(box) {
    if (box.dataset.hzReady) return;
    box.dataset.hzReady = '1';
    var formId = box.getAttribute('data-hz-offers');
    var form = document.getElementById(formId);
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var cards = $$('.hz-offer', box);
    function apply(input) {
      cards.forEach(function (c) { c.classList.toggle('is-selected', c.contains(input)); });
      if (idInput) {
        idInput.value = input.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncPrices({ price: input.dataset.price, compare: input.dataset.compare, save: input.dataset.save });
      var gal = $('[data-hz-gallery]');
      var target = input.dataset.slide;
      if (gal && gal.hzGo && target !== undefined && target !== '') gal.hzGo(parseInt(target, 10));
    }
    $$('input[type="radio"]', box).forEach(function (input) {
      input.addEventListener('change', function () { if (input.checked) apply(input); });
      if (input.checked) {
        cards.forEach(function (c) { c.classList.toggle('is-selected', c.contains(input)); });
        if (idInput) idInput.value = input.value;
      }
    });
  }

  /* ---------- add to cart: theme product-form first, fetch fallback ---------- */
  function initFormFallback(form) {
    if (form.dataset.hzReady) return;
    form.dataset.hzReady = '1';
    form.addEventListener('submit', function (e) {
      if (window.customElements && customElements.get('product-form') && form.closest('product-form')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.classList.add('is-loading');
      var skip = form.querySelector('[data-skip-cart="true"]');
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Error');
          window.location.href = skip ? '/checkout' : '/cart';
        })
        .catch(function (err) {
          if (btn) btn.classList.remove('is-loading');
          var box = form.parentNode.querySelector('.product-form__error-message-wrapper');
          if (box) {
            box.hidden = false;
            var msg = box.querySelector('.product-form__error-message');
            if (msg) msg.textContent = err.message;
          }
        });
    });
  }

  function submitMain() {
    var form = $('form[data-hz-main-form="true"]') || $('form[data-hz-form]');
    if (!form) return false;
    var btn = form.querySelector('[type="submit"]');
    if (typeof form.requestSubmit === 'function') form.requestSubmit(btn || undefined);
    else if (btn) btn.click();
    return true;
  }

  /* ---------- sticky bar ---------- */
  function initSticky() {
    var bar = $('[data-hz-sticky]');
    var anchor = $('[data-hz-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    document.body.classList.add('hz-has-sticky');
    var mainOut = false;
    var blockers = 0;
    function update() { bar.classList.toggle('is-visible', mainOut && blockers === 0); }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { mainOut = !en.isIntersecting && en.boundingClientRect.top < 0; });
      update();
    }).observe(anchor);
    var seen = new Map();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
      blockers = 0;
      seen.forEach(function (v) { if (v) blockers++; });
      update();
    });
    $$('[data-hz-sticky-hide]').forEach(function (el) { obs.observe(el); });
    var btn = $('[data-hz-sticky-btn]', bar);
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.dataset.mode === 'scroll' || !submitMain()) scrollToBuy();
    });
  }

  function scrollToBuy() {
    var t = $('[data-hz-buy-target]') || $('[data-hz-atc-anchor]');
    if (!t) { window.location.href = (window.hzProductUrl || '/'); return; }
    var y = t.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  /* ---------- generic buttons ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-hz-buy]');
    if (!a) return;
    if ($('[data-hz-buy-target]')) {
      e.preventDefault();
      if (a.dataset.hzBuy === 'submit') { if (!submitMain()) scrollToBuy(); }
      else scrollToBuy();
    }
  });

  /* ---------- country / currency picker ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-hz-loc]');
    if (sel && sel.form) sel.form.submit();
  });

  /* ---------- videos ---------- */
  function initVideo(card) {
    if (card.dataset.hzReady) return;
    card.dataset.hzReady = '1';
    var btn = $('.hz-vid__play', card);
    var video = $('video', card);
    if (!btn || !video) return;
    btn.addEventListener('click', function () {
      $$('.hz-vid.is-playing video').forEach(function (v) { if (v !== video) { v.pause(); } });
      if (!video.src && video.dataset.src) video.src = video.dataset.src;
      video.muted = false;
      video.controls = true;
      card.classList.add('is-playing');
      var p = video.play();
      if (p && p.catch) p.catch(function () { video.muted = true; video.play(); });
    });
    video.addEventListener('pause', function () { if (video.ended) card.classList.remove('is-playing'); });
  }

  /* ---------- rails ---------- */
  function initRailNav(wrap) {
    if (wrap.dataset.hzReady) return;
    wrap.dataset.hzReady = '1';
    var rail = $('[data-hz-rail]', wrap);
    if (!rail) return;
    $$('[data-hz-rail-dir]', wrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = parseInt(b.getAttribute('data-hz-rail-dir'), 10);
        var card = rail.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 14 : rail.clientWidth * .8;
        rail.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
    });
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    var els = $$('.hz-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init(root) {
    $$('[data-hz-gallery]', root).forEach(initGallery);
    $$('[data-hz-offers]', root).forEach(initOffers);
    $$('form[data-hz-form]', root).forEach(initFormFallback);
    $$('.hz-vid', root).forEach(initVideo);
    $$('[data-hz-rail-wrap]', root).forEach(initRailNav);
    initReveal();
  }

  function boot() { init(document); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); $$('.hz-reveal', e.target).forEach(function (el) { el.classList.add('is-in'); }); });
})();
